import { render, staticRenderFns } from "./PlusFile.vue?vue&type=template&id=5343a430&scoped=true"
import script from "./PlusFile.vue?vue&type=script&lang=js"
export * from "./PlusFile.vue?vue&type=script&lang=js"
import style0 from "./PlusFile.vue?vue&type=style&index=0&id=5343a430&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5343a430",
  null
  
)

export default component.exports